import { Outlet, Link, useLocation } from 'react-router-dom';
import {
  FiHome,
  FiShoppingBag,
  FiUser,
  FiMapPin,
  FiAward
} from 'react-icons/fi';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useTranslation } from 'react-i18next';

const CustomerLayout = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const menuItems = [
    { path: '/account', icon: FiHome, label: t('account.menu.overview') },
    { path: '/account/orders', icon: FiShoppingBag, label: t('account.menu.orders') },
    { path: '/account/profile', icon: FiUser, label: t('account.menu.profile') },
    { path: '/account/addresses', icon: FiMapPin, label: t('account.menu.addresses') },
    { path: '/account/affiliate', icon: FiAward, label: 'Bayi & Ortaklık Paneli' },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow bg-[#fafafa] pt-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
            {/* Sidebar */}
            <div className="lg:col-span-1">
              <div className="bg-white p-8 border border-gray-100">
                <h2 className="text-xl font-serif text-[#4a4a4a] mb-8 tracking-wide border-b border-gray-100 pb-4">{t('account.menu.myAccount')}</h2>
                <nav className="space-y-2">
                  {menuItems.map((item) => {
                    const Icon = item.icon;
                    const isActive = location.pathname === item.path;
                    return (
                      <Link
                        key={item.path}
                        to={item.path}
                        className={`flex items-center gap-4 px-4 py-3 transition-colors duration-300 ${isActive
                          ? 'bg-[#1a202c] text-white'
                          : 'text-gray-500 hover:bg-gray-50 hover:text-gray-900'
                          }`}
                      >
                        <Icon className="text-lg shrink-0" />
                        <span className="text-[11px] font-sans font-bold tracking-[0.15em] uppercase mt-0.5">{item.label}</span>
                      </Link>
                    );
                  })}
                </nav>
              </div>
            </div>

            {/* Content */}
            <div className="lg:col-span-3">
              <Outlet />
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CustomerLayout;

